
if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

// Function to add id "introParagraph" to the first paragraph
  function addIntroId() {
    const introParagraph = document.querySelector('.product__description p');
    introParagraph.id = 'introParagraph';
  }

  // Function to truncate the text content of the introductory paragraph to 50 words
  function truncateIntroParagraph() {
    const introParagraph = document.getElementById('introParagraph');
    const words = introParagraph.textContent.split(' ');
    const truncatedText = words.slice(0, 70).join(' ');

    introParagraph.textContent = truncatedText + '...';
  }

  // Function to add "Read More" button and hidden class to paragraphs
  function addReadMoreButton() {
    const productDescription = document.querySelector('.product__description');
    const paragraphs = productDescription.querySelectorAll('p, ul, span');

    // Add hidden class to all paragraphs except the first one
    for (let i = 1; i < paragraphs.length; i++) {
      paragraphs[i].classList.add('hidden');
    }

    // Create "Read More" button
    const readMoreButton = document.createElement('button');
    readMoreButton.textContent = 'Read More';
    readMoreButton.id = 'toggleButton';

    // Add event listener to toggle visibility of paragraphs
    readMoreButton.addEventListener('click', function() {
      paragraphs.forEach(paragraph => {
        paragraph.classList.toggle('hidden');
      });

      // Change button text based on visibility state
      if (readMoreButton.textContent === 'Read More') {
        readMoreButton.textContent = 'Read Less';
      } else {
        readMoreButton.textContent = 'Read More';
      }
    });

    // Append button to the product description
    productDescription.appendChild(readMoreButton);
  }
  window.addEventListener('load', function () {
  const shortDesc = document.querySelector('.product-description-short');
  const fullDesc = document.querySelector('.product-description-full');
  const readMore = document.querySelector('.read_more');
  const readLess = document.querySelector('.read_less');

  if (!shortDesc || !fullDesc || !readMore || !readLess) {
    return;
  }

  readMore.addEventListener('click', function () {
    shortDesc.style.display = 'none';
    fullDesc.style.display = 'block';
  });

  readLess.addEventListener('click', function () {
    shortDesc.style.display = 'block';
    fullDesc.style.display = 'none';
  });
});